module.exports = __webpack_public_path__ + "static/media/USP2Image.8b0970e2.png";